import auth from './auth';
import user from './user';
import load from './load';
import devices from './devices';
import events from './events';
import files from './files';
import admin from './admin';


export default {
  // user
  auth,
  user,
  load,
  devices,
  events,
  files,

  // admin
  admin
};
